import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { startCase } from 'lodash';
import { Field } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';

const ReminderDataField = () => {
  const {
    setFieldValue,
    values: {
      reminderData = {},
      reminderDataParsed = {},
    },
  } = useFormikContext();

  useEffect(() => {
    setFieldValue('reminderDataParsed', JSON.parse(reminderData));
  }, []);

  useEffect(() => {
    setFieldValue('reminderData', JSON.stringify(reminderDataParsed));
  }, [reminderDataParsed]);

  return (
    <>
      <Field
        type="hidden"
        name="reminderData"
      />

      <Row form>
        {[
          'add',
          'update',
          'cancel',
          'no-show',
        ].map(k => (
          <Col sm={6}>
            <Field
              type="text"
              name={`reminderDataParsed.${k}`}
              label={`Reminder Data ${startCase(k)}`}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ReminderDataField;
